function initSmgReviewsSliderSwiper(root) {
  var el = root.querySelector('[data-smg-reviews-slider-swiper]');
  if (!el || typeof Swiper === 'undefined') return;
  if (el.swiper) el.swiper.destroy(true, true);

  var namesWrap = root.querySelector('[data-smg-reviews-slider-names]');
  var nameButtons = namesWrap ? Array.prototype.slice.call(namesWrap.querySelectorAll('.smg-reviews-slider__name')) : [];

  function setActiveName(index) {
    nameButtons.forEach(function (button, i) {
      var isActive = i === index;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
  }

  var swiper = new Swiper(el, {
    slidesPerView: 1,
    spaceBetween: 0,
    navigation: {
      nextEl: root.querySelector('.smg-reviews-slider__nav--next'),
      prevEl: root.querySelector('.smg-reviews-slider__nav--prev')
    },
    a11y: {
      prevSlideMessage: 'Previous review',
      nextSlideMessage: 'Next review'
    },
    on: {
      slideChange: function () {
        setActiveName(this.activeIndex);
      }
    }
  });

  nameButtons.forEach(function (button, index) {
    button.addEventListener('click', function () {
      swiper.slideTo(index);
    });
  });
}

function initAllSmgReviewsSlider(scope) {
  var sections = (scope || document).querySelectorAll('.smg-reviews-slider');
  sections.forEach(function (section) {
    initSmgReviewsSliderSwiper(section);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    initAllSmgReviewsSlider(document);
  });
} else {
  initAllSmgReviewsSlider(document);
}

document.addEventListener('shopify:section:load', function (e) {
  initAllSmgReviewsSlider(e.target);
});
